import { Stack } from '@mui/material'
import React, { useContext } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'

import TestStatusCheck from 'components/rbac-settings/teams/TestStatusCheck'
import { PollingIntervalField } from 'components/status-checks/common/PollingIntervalField'
import { StatusCheckMonitorSelection } from 'components/status-checks/form/status-check/StatusCheckMonitorSelection'
import { StatusCheckNameMonitorSuccessEvaluation } from 'components/status-checks/form/status-check/StatusCheckNameMonitorSuccessEvaluation'
import {
  buildTeamExternalIntegration,
  type StatusCheckFormValues
} from 'components/status-checks/status-checks-form-utils'
import { StatusCheckDetailsContext } from 'context/status-checks/StatusCheckDetailsContext'
import { ObservabilityToolType } from 'types/api/status-checks/status-check'

export const StatusCheckUrlAndSuccessEvaluation: React.FC = () => {
  const { control, getValues } = useFormContext<StatusCheckFormValues>()

  const [observabilityTool, evaluationConfiguration] =
    useWatch<StatusCheckFormValues>({
      control,
      name: ['observabilityTool', 'evaluationConfiguration']
    })

  const isCustomObservabilityTool =
    observabilityTool.type === ObservabilityToolType.CUSTOM

  const isAWS = observabilityTool.type === ObservabilityToolType.AWS

  // Some monitoring frameworks allow for status check names to be matched to a monitor/alert name and accessed from
  // their API. Where this is available, we use that value in lieu of a custom name.  We use this flag to hide the
  // "statusCheckName" field when this is the case.
  //
  // Currently, the only tool configured this way are Datadog and AWS. This flag will need to be modified if/when more are added.
  const isAutomatedObservabilityTool =
    observabilityTool.type === ObservabilityToolType.DATADOG ||
    observabilityTool.type === ObservabilityToolType.AWS

  const { handleSuccess, isTestStatusCheckDisabled } = useContext(
    StatusCheckDetailsContext
  )

  return (
    <Stack spacing={4}>
      <Stack spacing={1}>
        {isAutomatedObservabilityTool ? (
          <StatusCheckMonitorSelection />
        ) : (
          <StatusCheckNameMonitorSuccessEvaluation />
        )}
      </Stack>
      {!isCustomObservabilityTool && !isAWS && (
        <TestStatusCheck
          disabled={isTestStatusCheckDisabled}
          evaluationConfiguration={evaluationConfiguration}
          integration={buildTeamExternalIntegration(getValues())}
          onSuccess={handleSuccess}
        />
      )}
      <PollingIntervalField />
    </Stack>
  )
}
